import { render, staticRenderFns } from "./lastevents.vue?vue&type=template&id=2743fad0&scoped=true&"
import script from "./lastevents.vue?vue&type=script&lang=js&"
export * from "./lastevents.vue?vue&type=script&lang=js&"
import style0 from "./lastevents.vue?vue&type=style&index=0&id=2743fad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743fad0",
  null
  
)

export default component.exports